import { Box, IconButton } from '@mui/material';
import React, { useState } from 'react';

type VisibilityButtonProps = {
  isOff: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const VisibilityButton = ({ isOff, onClick }: VisibilityButtonProps) => {
  const [hover, setHover] = useState(false);
  return (
    <Box ml={0.5}>
      <IconButton
        sx={{ minWidth: 0, padding: 0 }}
        onClick={onClick}
        onMouseOver={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-testid={isOff ? 'visibility-off' : 'visibility-on'}
      >
        <img
          src={`/images/worksheet/visibility${hover ? '-hover' : ''}${
            isOff ? '-off' : ''
          }.svg`}
          alt="show-space-type"
        />
      </IconButton>
    </Box>
  );
};

export default VisibilityButton;
